import { isShowActualRecipesEnabledFromAppConfig } from '../config';
import { getApiText } from '../../../shared/i18n';

export type RecipeDisplayMode = 'none' | 'text' | 'ingredients';

export type RecipeDisplayContent = {
  mode: RecipeDisplayMode;
  recipe_text?: string;
  recipe_items?: unknown[];
};

/** Recipe display mode from app_config (`show_actual_recipes`), with org fallback when app_config failed. */
export function isShowActualRecipesEnabled(): boolean {
  return isShowActualRecipesEnabledFromAppConfig();
}

function extractRecipeText(item: Record<string, unknown>): string {
  const localized = getApiText(item, 'recipe_text', 'a_recipe_text');
  if (typeof localized === 'string' && localized.trim().length > 0) {
    return localized.trim();
  }
  const plain = item.recipe_text;
  if (typeof plain === 'string' && plain.trim().length > 0) {
    return plain.trim();
  }
  return '';
}

function extractRecipeItems(item: Record<string, unknown>): unknown[] {
  const recipes = item.recipes;
  return Array.isArray(recipes) && recipes.length > 0 ? recipes : [];
}

/**
 * `show_actual_recipes` false/0 → prose `recipe_text` (hidden when empty).
 * `show_actual_recipes` true/1 → structured `recipes` ingredient chips (hidden when empty).
 */
export function resolveRecipeDisplay(item: Record<string, unknown> | null | undefined): RecipeDisplayContent {
  if (item == null || typeof item !== 'object') {
    return { mode: 'none' };
  }

  if (isShowActualRecipesEnabled()) {
    const recipe_items = extractRecipeItems(item);
    if (recipe_items.length === 0) {
      return { mode: 'none' };
    }
    return { mode: 'ingredients', recipe_items };
  }

  const recipe_text = extractRecipeText(item);
  if (!recipe_text) {
    return { mode: 'none' };
  }
  return { mode: 'text', recipe_text };
}
